import { Phase, Contract } from "@/types/contract";
import { Flow } from "../types";
import { SCREENS } from "../screens";
import { shouldCollectGDPRAgreements } from "@/utils/contract";
import { isCustomerIdentified, requireYearConsumption, showAttachmentsScreen, skipTariffAndPayments } from "../helpers";

export const R1_SELF_SERVICE: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => {
      if (contract.phase === Phase.CONTRACT_FROM_REQUEST) {
        if (showAttachmentsScreen(contract)) {
          return SCREENS.ATTACHMENTS;
        }
        if (requireYearConsumption(contract)) {
          return SCREENS.SUPPLY_POINT;
        }
        return SCREENS.TARIFF;
      }
      if (isCustomerIdentified(contract)) {
        return SCREENS.CUSTOMER;
      }
      return SCREENS.IDENTIFICATION;
    },
    back: () => null,
  },
  [SCREENS.ATTACHMENTS]: {
    next: (contract: Contract) => {
      if (contract.phase === Phase.CONTRACT_FROM_REQUEST && requireYearConsumption(contract)) {
        return SCREENS.SUPPLY_POINT;
      }
      return SCREENS.TARIFF;
    },
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.IDENTIFICATION]: {
    next: () => SCREENS.CUSTOMER,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.GUIDE,
    back: () => SCREENS.IDENTIFICATION,
  },
  [SCREENS.GUIDE]: {
    next: () => SCREENS.SUPPLY_POINT,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.SUPPLY_POINT]: {
    next: (contract: Contract) => {
      if (skipTariffAndPayments(contract)) {
        return SCREENS.RECAPITULATION;
      }
      if (contract.phase === Phase.CONTRACT || contract.phase === Phase.CONTRACT_FROM_REQUEST) {
        return SCREENS.TARIFF;
      }
      return SCREENS.RECAPITULATION;
    },
    back: (contract: Contract) => {
      if (contract.phase === Phase.CONTRACT_FROM_REQUEST && showAttachmentsScreen(contract)) {
        return SCREENS.ATTACHMENTS;
      }
      if (contract.phase === Phase.CONTRACT_FROM_REQUEST) {
        return SCREENS.WELCOME;
      }
      return SCREENS.GUIDE;
    },
  },
  [SCREENS.TARIFF]: {
    next: () => SCREENS.PAYMENTS,
    back: (contract: Contract) => {
      if (contract.phase === Phase.CONTRACT_FROM_REQUEST) {
        if (showAttachmentsScreen(contract)) {
          return SCREENS.ATTACHMENTS;
        }
        return SCREENS.WELCOME;
      }
      return SCREENS.SUPPLY_POINT;
    },
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.TARIFF,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) => {
      if (contract.phase === Phase.LEAD) {
        return SCREENS.THANK_YOU;
      }
      return !options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)
        ? SCREENS.AGREEMENTS
        : SCREENS.VIEW;
    },
    back: (contract: Contract) => {
      if (contract.phase === Phase.REQUEST || skipTariffAndPayments(contract)) {
        return SCREENS.SUPPLY_POINT;
      }
      return SCREENS.PAYMENTS;
    },
  },
  [SCREENS.AGREEMENTS]: {
    next: () => SCREENS.VIEW,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
